import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import toastError from "../../components/notif";
import { api } from "./index.api";
import { createEntityAdapter, EntityState } from "@reduxjs/toolkit";
import { Question } from "../../types/quize";

function questionsApiErrorHandler(error: FetchBaseQueryError) {
  switch (error.status) {
    default:
      toastError("unkown error please try again later");
  }
}
const questionsEntity = createEntityAdapter<Question, string>({
  selectId: (question: Question) => question._id,
});

const QuestionApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getQuizeQuestions: builder.query<
      EntityState<Question, string>,
      {
        quizeId: string;
      }
    >({
      query: (input) => `/quizes/${input.quizeId}/questions`,
      transformResponse(baseQueryReturnValue: { questions: any }, meta, arg) {
        return questionsEntity.addMany(
          questionsEntity.getInitialState(),
          baseQueryReturnValue.questions as any
        );
      },
      async onQueryStarted(arg, api) {
        try {
          await api.queryFulfilled;
        } catch (error: any) {
          questionsApiErrorHandler(error.error as FetchBaseQueryError);
        }
      },
      providesTags: (res, err, api) => {
        if (err) return [];
        return [
          {
            type: "questions",
            id: api.quizeId,
          },
        ];
      },
    }),
    addQuestions: builder.mutation<
      void,
      { quizeId: string; data: Omit<Question, "_id"> }
    >({
      query: (input) => ({
        url: `/admin/quizes/${input.quizeId}/questions`,
        method: "POST",
        body: input.data,
      }),
      async onQueryStarted(arg, api) {
        try {
          await api.queryFulfilled;
        } catch (error: any) {
          questionsApiErrorHandler(error.error as FetchBaseQueryError);
        }
      },
      invalidatesTags: (res, err, api) => {
        if (err) return [];
        return [
          {
            type: "questions",
            id: api.quizeId,
          },
        ];
      },
    }),
    deleteQuestion: builder.mutation<void, { quizeId: string; index: number }>({
      query: (input) => ({
        url: `/admin/quizes/${input.quizeId}/questions/${input.index}`,
        method: "DELETE",
      }),
      async onQueryStarted(arg, api) {
        try {
          await api.queryFulfilled;
        } catch (error: any) {
          questionsApiErrorHandler(error.error as FetchBaseQueryError);
        }
      },
      invalidatesTags: (res, err, api) => {
        if (err) return [];
        return [
          {
            type: "questions",
            id: api.quizeId,
          },
        ];
      },
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetQuizeQuestionsQuery,
  useAddQuestionsMutation,
  useDeleteQuestionMutation,
} = QuestionApi;
